export const global = {
  colon: ":",
  comma: ", ",
  all: "All",
  delete: "Delete",
  edit: "Edit",
  view: "View",
  add: "Add",
  apply: "Apply",
  confirm: "Confirm",
  warning: "Warning",
  save: "Save",
  cancel: "Cancel",
  discard: "Discard",
  empty: "Empty",
  yes: "Yes",
  no: "No",
  ok: "OK",
  saveAs: "Save as",
  noData: "No Data",
  none: "None",
  applyToAll: "Apply to all",
  confirmDeletion: "Confirm Deletion",
  deletedSuccessfully: "Deleted successfully.",
  failedToDelete: "Failed to delete.",
  savedSuccessfully: "Saved successfully.",
  failedToSave: "Failed to save.",
  loading: "Loading...",
  retry: "Retry",
  secs: "Sec | Secs",
  mph: "mph",
  kmh: "km/h",
  mm: "mm",
  in: "in",
  subtitle: "Displayed Fields",
  to: "to",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  minimumCharactersLong: "A minimum of {0} characters must be used",
  maximumCharactersCanUsed: "A maximum of {0} characters can be used",
  mustContainBetweenCharacters: "Must contain between {0} and {1} characters",
  unknownDriver: "Unknown Driver",
  NA: "N/A",
  pleaseSelect: "Please select",
  phoneNumberTips: "It should be formed by 0-9",
  unitGB: "GB",
  m: "m",
  ft: "ft",
  onlyLengthCharactersCanBeUsed: "Only {0} characters can be used",
  cm: "cm",
  calenderYearMonth: "{year} {month}",
  calenderYear: "{year}",
  calenderMonth1: "Jan",
  calenderMonth2: "Feb",
  calenderMonth3: "Mar",
  calenderMonth4: "Apr",
  calenderMonth5: "May",
  calenderMonth6: "Jun",
  calenderMonth7: "Jul",
  calenderMonth8: "Aug",
  calenderMonth9: "Sep",
  calenderMonth10: "Oct",
  calenderMonth11: "Nov",
  calenderMonth12: "Dec",
  calenderDayOfWeek1: "Mon",
  calenderDayOfWeek2: "Tue",
  calenderDayOfWeek3: "Wed",
  calenderDayOfWeek4: "Thu",
  calenderDayOfWeek5: "Fri",
  calenderDayOfWeek6: "Sat",
  calenderDayOfWeek7: "Sun",
  noMatchingData: "No matching data",
  mapLoadError: "Failed to load map",
  startMonth: "Start Month",
  endMonth: "End Month",
  startDate: "Start Date",
  endDate: "End Date",
  back: "Back",
};
